import { Component, Input } from '@angular/core';

@Component({
  selector: 'version-pill',
  templateUrl: './version-pill.component.html',
  standalone: false
})

export class VersionPillComponent {
  @Input() label: string = 'BETA';
}
